import { useQuery } from "@tanstack/react-query";
import { useCommonStore } from "../../store";
import { getSolutionApi } from "../../services/solution/get.solution.api";

export const useGetAllSolutionApi = () => {
  const { reload } = useCommonStore();
  const { data, isLoading } = useQuery({
    queryKey: ["solution", reload],
    queryFn: () => getSolutionApi(),
    enabled: true,
  });
  return {
    solution: data,
    isLoading,
  };
};
